package core.validation.field

import core.validation.validator.Validator

class IntField(
    private vararg val validators: Validator<Int>,
) : FieldImpl<Int>(
        initialValue = 0,
        validators = validators,
    )
